<template>
<transition name="modal">
    <div v-if="show" ref="modalContainer">
        <div :class="['modal show modal-scroll', modalClasses]" :style="styleObject" tabindex="-1" role="dialog" @click.stop="closeBackdrop" ref="modal">
            <div :class="'modal-dialog ' + modalSizeClasses" role="document" @click.stop="">
                <div class="modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>

        <div v-if="includeBackdrop" class="modal-backdrop show" style="z-index: 1040 !important;"></div>
    </div>
</transition>
</template>

<script>
export default {
    props: {
        "modalClasses": {
            default: ""
        },
        "isLarge": {
            default: false
        },
        "isSmall": {
            default: false
        },
        "show": {
            default: false
        },

        "includeBackdrop": {
            default: true
        },
        "locked": {
            default:false
        }
    },
    data() {
        return {
            styleObject: {
                display: 'block'
            }
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeBackdrop() {
            if(this.locked){
                return;
            }
            this.close();
        }
    },
    computed: {
        modalSizeClasses() {
            if (this.isLarge) {
                return " modal-xl";
            }
            if (this.isSmall) {
                return " modal-sm";
            }
            return "";
        },
    },
    watch:{
        show(value){
            if(value){
                var temp = this;
                this.$nextTick(function(){
                    document.body.appendChild(temp.$refs["modalContainer"]);
                })
                
            }
        },

    },

    mounted() {},
    destroyed() {
        this.$el.remove();
    }
}
</script>

<style lang="css" scoped>
.modal-scroll {
    overflow-y: auto;
    .modal-content {
        overflow: visible;
    }
}

/* Transitions */
.modal-enter-active,
.modal-leave-active {
    transition: opacity .2s linear;
}

.modal-enter-active .modal-backdrop {
    transition: opacity .1s linear;
}

.modal-leave-active .modal-backdrop {
    transition: opacity .1s linear;
    transition-delay: .1s;
}

.modal-enter-active .modal {

    transition: opacity .1s linear;
    transition-delay: .1s;
}

.modal-leave-active .modal {

    transition: opacity .1s linear;
}

.modal-enter .modal,
.modal-leave-to .modal,
.modal-leave-active .modal,
.modal-enter .modal-backdrop,
.modal-leave-to .modal-backdrop,
.modal-leave-active .modal-backdrop {
    opacity: 0
}

.modal-enter .modal-dialog,
.modal-leave-to .modal-dialog,
.modal-leave-active .modal-dialog {
    //transform: translate(0, -5%);
}
</style>
